// ADDED
import React, { useState } from 'react';
import { MonthPickerInput } from './MonthPickerInput';
import { MonthPickerModal } from './MonthPickerModal';

export function MonthPickerField({
  label,
  isRequired = true,
  value, // e.g., "January"
  onSelect,
  onClear,
  error = false,
  errorMessage = "",
  placeholder = "--Select Month--",
  disabled = false,
  allowAll = false
}) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleSelect = (month) => {
    onSelect(month);
    setIsModalOpen(false);
  };

  return (
    <>
      <MonthPickerInput
        label={label}
        isRequired={isRequired}
        value={value}
        placeholder={placeholder}
        error={error}
        errorMessage={errorMessage}
        hasSelection={!!value}
        onSelectClick={() => !disabled && setIsModalOpen(true)}
        onClearClick={onClear}
        disabled={disabled}
      />

      <MonthPickerModal
        isOpen={isModalOpen}
        onClose={() => setIsModalOpen(false)}
        onSelect={handleSelect}
        selectedValue={value}
      />
    </>
  );
}